import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.isExternal ? (_openBlock(), _createElementBlock("div", _mergeProps({
    key: 0,
    class: "svg-external-icon svg-icon"
  }, _ctx.$attrs), null, 16)) : (_openBlock(), _createElementBlock("svg", _mergeProps({
    key: 1,
    class: $options.svgClass,
    "aria-hidden": "true"
  }, _ctx.$attrs), [_createElementVNode("use", {
    href: $options.iconName
  }, null, 8, _hoisted_1)], 16));
}